import Breadcrumbs from '@/components/breadcrumbs/breadcrumbs.component';
import { AdminHeaderProps } from '@/components/headers/headers.props';
import { H2 } from '@/components/typography';
import { cn } from '@/lib/utils';

export const AdminHeader = ({ title, breadcrumbs, callToAction, searchAndFilter }: AdminHeaderProps) => (
  <div className={cn('w-full flex flex-col')}>
    <div className="min-h-[32px] min-w-[200px]">{breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}</div>
    <div className={cn('flex flex-row justify-between mt-2 mb-2')}>
      <div className={cn('flex flex-col gap-2 w-full')}>
        <H2 className={cn('text-neutral-800 mb-6')}>{title}</H2>
        {searchAndFilter && searchAndFilter}
      </div>
      <div className={cn('flex min-w-max')}>{callToAction && callToAction}</div>
    </div>
  </div>
);
